import React, { Component } from 'react'

// import Colors from "../../Colors";

class Input extends Component {
    constructor(props) {
        super(props)
        this.state = {
            inputValue:
                props.value === undefined || props.value === null
                    ? 0
                    : props.value,
            isFocused: false,
        }
    }

    componentDidUpdate(prevProps) {
        // keep the field in sync with external updates, but never while the
        // user is actively typing so partial/exact input is preserved
        if (!this.state.isFocused && prevProps.value !== this.props.value) {
            this.setState({
                inputValue:
                    this.props.value === undefined ||
                    this.props.value === null
                        ? 0
                        : this.props.value,
            })
        }
    }

    onFocus = () => {
        this.setState({ isFocused: true })
    }

    onChange = (e) => {
        const raw = e.target.value
        // allow clearing and free typing; range correction happens on blur
        this.setState({ inputValue: raw })

        if (raw !== '' && raw !== '-' && !isNaN(raw)) {
            this.props.onChange(raw)
        }
    }

    commitValue = () => {
        const { onChange, min, max } = this.props
        let value = this.state.inputValue
        if (value === '' || value === '-' || isNaN(value)) {
            value = min
        } else {
            value = Number(value)
            if (value < min) value = min
            else if (value > max) value = max
        }
        this.setState({ inputValue: value, isFocused: false })
        onChange(value)
    }

    onBlur = () => {
        this.commitValue()
    }

    onKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.target.blur()
        }
    }

    render() {
        const { disabled, min, max } = this.props
        var style = {
            width: '65px',
            height: '25px',
            display: 'inline-block',
            textAlign: 'center',
            borderRadius: '20px',
            color: 'black',
            ...this.props.style,
        }
        if (disabled) style.borderBottom = '0.140em solid #B8B8B8'
        return (
            <input
                className="inputDigit"
                style={style}
                type="number"
                inputMode="numeric"
                value={this.state.inputValue}
                min={min}
                max={max}
                disabled={disabled}
                onFocus={this.onFocus}
                onChange={this.onChange}
                onBlur={this.onBlur}
                onKeyDown={this.onKeyDown}
            />
        )
    }
}

export default Input
